import Enumeration from 'Lib/utilities/Enumeration';

const ApplicationSteps = new Enumeration([
    { id: 1, name: 'ApplyingFor' },
    { id: 2, name: 'PersonalInfo' },
    { id: 3, name: 'Occupants' },
    { id: 4, name: 'AddressHistory' },
    { id: 5, name: 'EmploymentIncome' },
    { id: 6, name: 'FinancialDetails' },
    { id: 7, name: 'QuestionsTerms' },
    { id: 8, name: 'Documents' },
    { id: 9, name: 'ReviewSign' },
    { id: 10, name: 'Pay' },
    { id: 11, name: 'ApplicationInstructions' },
    { id: 12, name: 'Addenda' },
    { id: 13, name: 'IncomeVerification' },
    { id: 14, name: 'IdentityVerification' }
]);

export default ApplicationSteps;
